import { useState } from 'react'
import type { Channel } from '../types'

interface Props {
  channel: Pick<Channel, 'slug' | 'profile_picture_url'>
  size?: number
  className?: string
}

// Kick profil resmi varsa <img> ile göster, yoksa veya yüklenemezse slug
// initial'lı renkli placeholder. Tutarlı 8px font / size oranı.
export function ChannelAvatar({ channel, size = 24, className = '' }: Props) {
  const [errored, setErrored] = useState(false)
  const initial = channel.slug.charAt(0).toUpperCase()
  const url = channel.profile_picture_url

  if (url && !errored) {
    return (
      <img
        src={url}
        alt={channel.slug}
        width={size}
        height={size}
        loading="lazy"
        onError={() => setErrored(true)}
        className={`rounded-full object-cover shrink-0 ${className}`}
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-gradient-to-br from-[var(--color-accent)] to-[#8a93f0] text-white font-semibold shrink-0 ${className}`}
      style={{ width: size, height: size, fontSize: Math.max(10, Math.floor(size * 0.42)) }}
      aria-label={channel.slug}
    >
      {initial}
    </span>
  )
}
